import React from 'react';

export default <g id="icon/drag/grey" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="2" cy="2" r="2"></circle>
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="10" cy="2" r="2"></circle>
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="2" cy="10" r="2"></circle>
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="10" cy="10" r="2"></circle>
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="2" cy="18" r="2"></circle>
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="10" cy="18" r="2"></circle>
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="2" cy="26" r="2"></circle>
    <circle id="Oval-10" fill="#D8D8D8" fillRule="nonzero" cx="10" cy="26" r="2"></circle>
</g>